import { render, staticRenderFns } from "./ChartData.vue?vue&type=template&id=0a70e656&scoped=true&"
import script from "./ChartData.vue?vue&type=script&lang=js&"
export * from "./ChartData.vue?vue&type=script&lang=js&"
import style0 from "./ChartData.vue?vue&type=style&index=0&id=0a70e656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70e656",
  null
  
)

export default component.exports